import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import CreateOrUpdateCourse from '@/components/editor/CreateOrUpdateCourse.vue'
  import { CourseModule } from '@/store/modules/course'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseInfoEditor',
  emits: ['has-course-changes', 'update-training-content'],
  setup(__props) {

  

  const { currentCourseId } = useCourse()

  const fetchingCourseModules = computed(() => CourseModule.coursesModuleMap[currentCourseId.value] === undefined)

  if (fetchingCourseModules.value && currentCourseId.value) {
    CourseModule.getCourseModules(currentCourseId.value)
  }

return { __sfc: true,currentCourseId, fetchingCourseModules, computed, CreateOrUpdateCourse, CourseModule, useCourse }
}

})